import { render, staticRenderFns } from "./commentReply.vue?vue&type=template&id=61f7511b&scoped=true&"
import script from "./commentReply.vue?vue&type=script&lang=js&"
export * from "./commentReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f7511b",
  null
  
)

export default component.exports